import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import MyGraphics from '../../../../common/MyGraphics/MyGraphics'
import { getPercentileData } from './PercentileData'
import { getDurationBetweenDates } from '../../../../../resources/utilities'
import { polyglot } from '../../../../../index'

function getDateForMonthsFromBirth (birth, months) {
  const start = moment(new Date(birth))
  const finalDate = start.add(months, 'M')
  if (moment(finalDate, true).isValid()) {
    return finalDate
  } else {
    return moment(months)
  }
}

export default class Graphics extends React.Component {
  getPatientDataForGraphic (patientBirthdate, patientData, graphicType) {
    const data = []
    if (patientData && patientData.consultations) {
      Object.keys(patientData.consultations).forEach(key => {
        const consultation = patientData.consultations[key]
        if (consultation.healthParameters) {
          const age = getDurationBetweenDates(patientBirthdate, consultation.date)
          data.push({
            x: moment(new Date(patientBirthdate)).add(moment.duration(age)).toDate().getTime(),
            y: Number(consultation.healthParameters[graphicType])
          })
        }
      })
    }
    return data
  }

  getGraphicTitle (graphicType) {
    return graphicType
  }

  getDataForGraphics (graphics) {
    const data = []
    const { birthDate, data: patientData, gender } = this.props.patient
    graphics.forEach(graphic => {
      const patientDataForGraphic = this.getPatientDataForGraphic(birthDate, patientData, graphic)
      const percentileArr = getPercentileData(gender, graphic)
      percentileArr.forEach(element => {
        element.data.forEach((inner, index) => {
          const x = getDateForMonthsFromBirth(birthDate, inner.x).toDate().getTime()
          element.data[index] = {x, y: inner.y}
        })
      })
      data.push({
        data: [{title: graphic,
          color: 'a6a6a6',
          type: 'mark',
          noHover: false,
          ignoreX: false,
          xType: 'time',
          data: patientDataForGraphic
        }, ...percentileArr],
        title: polyglot.t(`staticFields.graphics.${this.getGraphicTitle(graphic)}`),
        type: 'date'
      })
    })
    return data
  }

  getGraphicsForRange (rangeId) {
    switch (rangeId) {
      case '0':
        return this.getDataForGraphics(['bmi', 'cephalicPerimeter', 'height', 'weight'])
      case '1':
        return this.getDataForGraphics(['bmi', 'cephalicPerimeter', 'height', 'weight'])
      case '2':
        return this.getDataForGraphics(['bmi', 'cephalicPerimeter', 'height', 'weight'])
      case '3':
        return this.getDataForGraphics(['bmi', 'height', 'weight'])
      case '4':
        return this.getDataForGraphics(['bmi', 'height', 'weight'])
      case '5':
        return this.getDataForGraphics(['bmi', 'height', 'weight'])
      default:
        return null
    }
  }

  renderGraphicsForRange (rangeId) {
    const graphics = this.getGraphicsForRange(rangeId)
    return graphics.map((graphic, index) => {
      return <MyGraphics height={600} key={index} type={graphic.type} header={graphic.title} data={graphic.data} />
    })
  }
  render () {
    return <div>
      {this.renderGraphicsForRange(this.props.rangeId)}
    </div>
  }
}

Graphics.propTypes = {
  rangeId: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/Consultations/Range/Graphics/Graphics.js